module.exports = __webpack_public_path__ + "img/circle.5ec167bf.svg";